/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ "{pole": NonNullable<unknown>, "{deal_id": NonNullable<unknown>, "{field": NonNullable<unknown> }} Field_Expression_HintInputs */

const cs_field_expression_hint = /** @type {(inputs: Field_Expression_HintInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Použijte ${i?.["{pole"]}} z payloadu, např. ${i?.["{deal_id"]}}`)
};

const en_field_expression_hint = /** @type {(inputs: Field_Expression_HintInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Use ${i?.["{field"]}} from the trigger payload, e.g. ${i?.["{deal_id"]}}`)
};

/**
* | output |
* | --- |
* | "Use {{field}} from the trigger payload, e.g. {{deal_id}}" |
*
* @param {Field_Expression_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const field_expression_hint = /** @type {((inputs: Field_Expression_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_Expression_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_expression_hint(inputs)
	return cs_field_expression_hint(inputs)
});